export class Column {
    name = "";
    key = "";
    type = "string";
    bold = false;
    isExtendable = false;
    mapping = "";
}
